module.exports = __webpack_public_path__ + "static/media/Mall.c24dedfe.svg";